import { render, staticRenderFns } from "./AlertContent.vue?vue&type=template&id=05018544&scoped=true"
import script from "./AlertContent.vue?vue&type=script&lang=js"
export * from "./AlertContent.vue?vue&type=script&lang=js"
import style0 from "./AlertContent.vue?vue&type=style&index=0&id=05018544&lang=scss"
import style1 from "./AlertContent.vue?vue&type=style&index=1&id=05018544&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05018544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05018544')) {
      api.createRecord('05018544', component.options)
    } else {
      api.reload('05018544', component.options)
    }
    module.hot.accept("./AlertContent.vue?vue&type=template&id=05018544&scoped=true", function () {
      api.rerender('05018544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Alert/AlertContent.vue"
export default component.exports